import { Card, CardContent } from "@/components/ui/card";
import { Building2 } from "lucide-react";

interface Branch {
  id: string;
  name: string;
}

interface BranchContextCardProps {
  branches: Branch[];
  isSuperAdmin: boolean;
}

export const BranchContextCard = ({ branches, isSuperAdmin }: BranchContextCardProps) => {
  if (branches.length === 0) return null;

  return (
    <Card className="bg-primary/5 border-primary/20">
      <CardContent className="py-4">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Building2 className="h-5 w-5 text-primary" />
          </div>
          <div>
            <p className="text-sm text-muted-foreground">
              {isSuperAdmin ? "You have access to:" : "Your branch:"}
            </p>
            <p className="font-semibold text-lg">
              {isSuperAdmin 
                ? branches.map(b => b.name).join(" & ")
                : branches[0]?.name || "No branch assigned"
              }
            </p>
          </div>
        </div>
        {isSuperAdmin && (
          <p className="text-xs text-muted-foreground mt-2">
            As super admin, you can view and manage all branches
          </p>
        )}
      </CardContent>
    </Card>
  );
};
